<template>
  <CustomPage title="退货退款" style="background: #f7f7f7">
    <div slot="content">
      <div class="logistics-container">
        <div class="menu">
          <div class="cell">
            <div class="label">物流公司</div>
            <div class="value" @click="showCompany = true">
              <span>{{ form.logisticsCompany || '请选择物流公司' }}</span>
              <img :src="require('@/assets/setting/箭头.svg')" alt="" />
            </div>
          </div>
          <div class="cell">
            <div class="label">物流单号</div>
            <div class="value">
              <Field
                class="input"
                v-model="form.logisticsNo"
                placeholder="点此输入物流单号"
                input-align="right"
              />
            </div>
          </div>
          <div class="cell">
            <div class="label">发货时间</div>
            <div class="value" @click="showDeliveryTime = true">
              <span>{{ deliveryTime_c || '请选发货时间' }}</span>
              <img :src="require('@/assets/setting/箭头.svg')" alt="" />
            </div>
          </div>
        </div>
      </div>
      <div class="footer">
        <div class="btn" @click="submitForm">保存</div>
      </div>
      <Popup v-model="showCompany" position="bottom">
        <Picker
          title="选择物流公司"
          show-toolbar
          :columns="companyList"
          value-key="name"
          @confirm="companyConfirm"
          @cancel="showCompany = false"
        />
      </Popup>
      <Popup v-model="showDeliveryTime" position="bottom">
        <DatetimePicker
          type="date"
          title="选择年月日"
          :max-date="maxDate"
          v-model="currentDate"
          @confirm="deliveryTimeConfirm"
          @cancel="showDeliveryTime = false"
        />
      </Popup>
    </div>
  </CustomPage>
</template>

<script>
import Bus from '@/utils/bus'
import CustomPage from '@/components/custom-page.vue'
import { Field } from 'vant'
import { getLogisticsList, addLogistics } from '@/api/order/afterSale'
import { Picker, Popup, DatetimePicker, Toast } from 'vant'

export default {
  components: { CustomPage, Field, Picker, Popup, DatetimePicker },
  data() {
    return {
      id: this.$route.query.id,
      showCompany: false,
      showDeliveryTime: false,
      companyList: [],
      maxDate: new Date(),
      currentDate: new Date(),
      form: {
        logisticsCompany: null,
        code: null,
        logisticsNo: null,
        deliveryTime: null,
      },
    }
  },
  computed: {
    deliveryTime_c() {
      return this.form.deliveryTime
        ? this.dayjs(this.form.deliveryTime).format('YYYY-MM-DD')
        : null
    },
  },
  created() {
    this.getLogisticsList()
  },
  methods: {
    getLogisticsList() {
      getLogisticsList().then((res) => {
        this.companyList = res.data
      })
    },
    companyConfirm(val) {
      this.form.logisticsCompany = val.name
      this.form.code = val.code
      this.showCompany = false
    },
    deliveryTimeConfirm(val) {
      this.form.deliveryTime = this.dayjs(val).utc().format()
      this.showDeliveryTime = false
    },
    submitForm() {
      if (this.validForm()) {
        this.$store.dispatch('app/showLoading')
        addLogistics({ ...this.form, salesReturnId: this.id })
          .then((res) => {
            Toast.success('保存成功')
            Bus.$emit('refreshData', this.id)
            this.$router.back()
            this.$store.dispatch('app/hideLoading')
          })
          .catch(() => {
            this.$store.dispatch('app/hideLoading')
          })
      }
    },
    validForm() {
      if (!this.form.code) {
        Toast.fail('请选择物流公司')
        return false
      }
      if (!this.form.logisticsNo) {
        Toast.fail('请输入物流单号')
        return false
      }
      if (!this.form.deliveryTime) {
        Toast.fail('请选择发货时间')
        return false
      }
      return true
    },
  },
}
</script>

<style lang="less" scoped>
.logistics-container {
  padding: 22px 24px;
  .menu {
    padding: 0 20px;
    background-color: #fff;
    .cell {
      display: flex;
      justify-content: space-between;
      padding: 34px 0;
      font-size: 28px;
      line-height: 1em;
      .value {
        display: flex;
        align-items: center;
        img {
          margin-left: 10px;
        }
        .input {
          padding: 0;
          font-size: 28px;
          line-height: 1em;
        }
      }
    }
  }
}
.footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #fff;
  padding: 16px 40px;
  .btn {
    width: 100%;
    line-height: 68px;
    font-size: 28px;
    text-align: center;
    color: #fff;
    background: linear-gradient(135deg, #e82237 0%, #ff9d9d 100%);
    border-radius: 38px;
    border: 2px solid #fe6979;
  }
}
</style>